import Select from "react-select";
import CurrencyCustomInput from "../utils/CurrencyCustomInput";
import { Formik, useFormik } from "formik";
import { Button, Table, Form } from "react-bootstrap";
import { useIsAdmin, useIsCashier, useTaxOptions } from "../../utils/hooks";
import * as yup from "yup";
import { useAuth } from "../../hooks/useAuth";
import { toast } from "react-toastify";
import { useMutation, useQuery } from "react-query";
import { useEffect, useMemo, useRef, useState } from "react";
import currency from "currency.js";
import { Link, useNavigate } from "react-router-dom";
import ModalLoader from "../utils/ModalLoader";
import {
  BookIcon,
  CashSelectIcon,
  CheckCircleIcon,
  ChequeSelectIcon,
  CircleTickedIcon,
  CreditSelectIcon,
  DirectTransferSelectIcon,
  DropdownCloseIcon,
  EditIcon,
  PrintIcon,
  RecieptIcon,
  UserIconTwo,
  UserSolidIcon,
} from "../Icons";
import {
  last,
  isEmpty,
  lowerCase,
  cloneDeep,
  range,
  values,
  uniqBy,
  set,
} from "lodash";
import { queryActions } from "../../utils/reactQueryActions";
import PaymentAccountDialog from "../PaymentAccountDialog";
import ConfirmDialog, {
  ConfirmExpenseChoiceDialog,
  ConfirmPostPurchasePaymentDialog,
} from "../ConfirmDialogue";
import {
  formatDate,
  hasAClosedTrack,
  requisitionLink,
  resolveApprovalBadgeBg,
  waitFor,
} from "../../utils/helpers";
import ApprovalBadge from "../utils/ApprovalBadge";
import { actionOn, useStoreState } from "easy-peasy";
import NewRequisitionModal from "./NewRequisition";
import EyeOutlineIcon from "mdi-react/EyeOutlineIcon";
import { description } from "platform";
import RaisePurchaseRequestGrn from "./RaisePurchaseRequestGrn";
import { FaDollarSign, FaMoneyBillAlt } from "react-icons/fa";
import AfterGRNRaisedDropdown from "./PurchaseRequest/AfterGRNRaisedDropdown";
import NewPurchaseRequisitionModal from "./NewPurchaseRequisitionModal";

const paymentTypesForPurchaseRequest = [
  {
    label: "Direct (Vendor)",
    value: "Direct",
  },
  {
    label: "Advanced (Employee)",
    value: "Advance",
  },
  {
    label: "Pre-payment (Vendor)",
    value: "Pre-payment",
  },
];

const paymentMethod = [
  {
    icon: <CreditSelectIcon />,
    label: "Imprest",
    value: "Imprest",
  },
  {
    icon: <CashSelectIcon />,
    label: "Cash",
    value: "Cash",
  },

  {
    icon: <ChequeSelectIcon />,
    label: "Cheque",
    value: "Cheque",
  },

  {
    icon: <DirectTransferSelectIcon />,
    label: "Direct Bank Transfer",
    value: "Direct Bank Transfer",
  },
  {
    icon: <CreditSelectIcon />,
    label: "Credit/Debit Card (POS)",
    value: "Credit/Debit Card",
  },
];

const cashOptions = [
  {
    label: "Cash On Hand",
    value: "Cash on hand",
  },
];

function Attachments({ files = [], setFiles }) {
  //  const [files, setFiles] = useState([]);
  const { backendUrl } = useAuth();
  return (
    <div>
      <Form.Label className="btn btn-light-blue">
        <span>Add Files </span>
        <Form.Control
          type="file"
          className="d-none"
          multiple
          onChange={e => setFiles([...files, ...e.target.files])}
        />
      </Form.Label>

      <div>
        {files?.map((el, index) => (
          <div key={index}>
            {el?.fileId ? (
              <a
                href={`${backendUrl}/api/requisition/files/${
                  el.systemFileName
                }/${el.name}`}
                target="_blank"
                rel="noreferrer"
              >
                {el?.name}
              </a>
            ) : (
              <span>{el?.name}</span>
            )}

            <Button
              variant=""
              size="sm"
              onClick={e => setFiles(files.filter((el, i) => i !== index))}
            >
              <DropdownCloseIcon />
            </Button>
            <hr className="m-0" />
          </div>
        ))}
      </div>
    </div>
  );
}

export default function PurchaseRequestForm({
  requisition,
  tableData,
  total,
  refetch,
  purchaseRequest,
  currencySymbol,
  expensedAccounts = [],
  attachedRequest,
  raisedGRNs = [],
  vendorTaxes = [],
  handlePurchaseRequestFormChanges,
  allStaffs = [],
}) {
  const taxOptions = useTaxOptions();
  const generalSettings = useStoreState(state => state.generalSettings);
  const isCashier = useIsCashier();
  const { backendUrl, token, user: authUser } = useAuth();
  const navigate = useNavigate();
  const [showNewRequisitionModal, setShowNewRequisitionModal] = useState(false);
  const amountExpensedRef = useRef();
  const isAdmin = useIsAdmin();
  const [grn, setRaiseGRN] = useState(false);
  const [
    selectedVendorToRaiseGRNFor,
    setSelectedVendorToRaiseGRNFor,
  ] = useState(null);

  const postPrepaymentData = async payload => {
    let response = await fetch(
      `${backendUrl}/api/requisition/post-pre-payment/${requisition.requestid}`,
      {
        method: "POST",
        credentials: "include",
        body: JSON.stringify(payload),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (!response.ok) {
      response = await response.json();
      throw new Error(response.message);
    }
    const res = await response.json();
    return res;
  };

  const postPrePaymentMutation = useMutation(
    payload => postPrepaymentData(payload),
    {
      onSuccess: ({ message }) => {
        toast.success(message);
        refetch();
      },
      onError: ({ message = "" }) => {
        toast.error(`Unable to perform action: ${message}`);
      },
      onSettled: () => {
        formik.setFieldValue("retireNow", false);
      },
    }
  );

  // ==============================================================

  const postRequisitionData = async payload => {
    const formData = new FormData();
    for (const [key, value] of Object.entries(payload)) {
      if (key === "files") {
        for (const file of value) {
          //  console.log(Boolean(!file?.fileId));
          if (!file?.fileId) {
            formData.append("files", file);
          }
        }
        continue;
      }
      formData.append(key, value);
    }
    formData.append(
      "alreadyUploadedFiles",
      JSON.stringify(payload.files.filter(el => el.fileId))
    );
    let response = await fetch(
      `${backendUrl}/api/requisition/update-data/${requisition.requestid}`,
      {
        method: "POST",
        credentials: "include",
        body: formData,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (!response.ok) {
      response = await response.json();
      throw new Error(response.message);
    }
    const res = await response.json();
    return res;
  };
  const postMutation = useMutation(payload => postRequisitionData(payload), {
    onSuccess: ({ message }) => {
      toast.success(message);
    },
    onError: ({ message = "" }) => {
      toast.error(`Unable to perform action: ${message}`);
    },
    onSettled: () => {
      formik.setFieldValue("retireNow", false);
    },
  });

  const closeRequisitionData = async payload => {
    // console.log(payload);
    const formData = new FormData();
    for (const [key, value] of Object.entries(payload)) {
      formData.append(key, value);
    }
    let response = await fetch(
      `${backendUrl}/api/requisition/update-sub/${requisition.requestid}`,
      {
        method: "POST",
        credentials: "include",
        body: formData,
        headers: {
          /*   Accept: "Application/json",
          "Content-Type": "Application/json", */
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (!response.ok) {
      response = await response.json();
      throw new Error(response.message);
    }
    const res = await response.json();
    return res;
  };
  const closeOutMutation = useMutation(
    payload => closeRequisitionData(payload),
    {
      onSuccess: ({ message }) => {
        // toast.success(message);
      },
      onError: ({ message = "" }) => {
        toast.error(`Unable to perform action: ${message}`);
      },
    }
  );

  ///========================================================================================================================================
  const updateRequisition = async payload => {
    let formData = new FormData();

    //------------------------------------------------------------
    for (const [key, value] of Object.entries(payload)) {
      formData.append(key, value);
    }

    let response = await fetch(
      `${backendUrl}/api/requisition/update/${requisition?.requestid}`,
      {
        method: "POST",
        credentials: "include",
        body: formData,
      }
    );

    if (!response.ok) {
      response = await response.json();
      throw new Error(response.message);
    }

    const { data } = await response.json();
    return data;
  };

  const updateRequisitionMutation = useMutation(
    payload => updateRequisition(payload),
    {
      onSuccess: () => {
        toast.success("Requisition updated successfully");
      },
      onError: ({ message }) => {
        toast.error(`Unable to save: ${message}`);
      },
    }
  );

  const formik = useFormik({
    initialValues: {
      By: "",
      From: "",
      initialAdvancePayment: 0,
      paymentType: "",
      amountAdvanced: 0,
      amountExpensed: 0,
      files: [],
      //purchaseRequestRemark: "",
      /* reimburseBy: "Imprest",
      reimburseFrom: "", */

      retireNow: false,
      requesterAccountName: "",
      requesterAccountNumber: "",
      requesterBank: "",

      // =======================
      initialPrePayment: 0,
      Vendor_ID: "",
      vendor: "",
      invoiceNumber: "",
    },
    validationSchema: yup.object().shape({
      paymentType: yup.string().required("required"),
      initialAdvancePayment: yup.number().required("required"),
      //  .moreThan(0, "must be greater than 0"),
    }),
    onSubmit: values => {
      // first time
      if (isEmpty(requisition.paymentType) && values.paymentType === "Direct") {
        values.invoiceNumber = [null, "null"].includes(values.invoiceNumber)
          ? ""
          : values.invoiceNumber;
        const numberOfLines = tableData.length;
        const filledInvoices = tableData.filter(el => el.invoiceNumber).length;

        if (filledInvoices > 0 && numberOfLines !== filledInvoices) {
          return toast.error("Please enter Invoice Number in all items");
        }

        if (filledInvoices === 0 && !formik.values.invoiceNumber) {
          return toast.error("Enter Invoice Number to continue");
        }
      }

      // Advanced Payment Validation - First time only
      const errors = {};
      if (
        isEmpty(requisition.paymentType) &&
        values.paymentType === "Advance"
      ) {
        values.invoiceNumber =
          values.invoiceNumber == null ? "" : values.invoiceNumber;

        if (isEmpty(values.By)) {
          errors.By = "Required";
        }
        if (isEmpty(values.From)) {
          errors.From = "Required";
        }
        if (
          isEmpty(values.initialAdvancePayment) ||
          Number(values.initialAdvancePayment) == 0
        ) {
          errors.initialAdvancePayment = "Required";
        }
      }

      if (!isEmpty(errors)) {
        formik.setErrors(errors);
        return;
      }

      //
      if (
        values.paymentType !== "Direct" &&
        requisition?.initialAdvancePayment &&
        Number(values.amountExpensed) !==
          Number(requisition?.initialExpenseAmount) &&
        Number(total.value) !== Number(values.amountExpensed)
      ) {
        formik.setFieldError(
          "amountExpensed",
          //"Amount Advanced and initial Expense do not match.\n please adjust items to match  Amount Advanced"
          "Amount does not match items in requisition. \n Please adjust items to match"
        );

        //  toast.error("...");
      } else {
        values.amountAdvanced = values.initialAdvancePayment;

        //-------

        let description = [
          ...tableData,
          ...(purchaseRequest?.description ? [purchaseRequest] : []),
        ]
          .map(el => {
            delete el.subtotal;
            return Object.values(el).join(",,,");
          })
          .join("&&&");

        description = description + "&&&";

        //-------
        postMutation.mutate(
          {
            ...values,
            reimburseToCompany,
            reimburseToEmployee,

            description,
            //  amount: total,
            ...(requisition?.status === "Pending Payment" &&
            values.paymentType === "Advance"
              ? { status: "Pending Retirement" }
              : ["Pending Retirement", "Retirement Confirmation"].includes(
                  requisition?.status
                ) &&
                values.paymentType === "Advance" &&
                (Number(reimburseToCompany) > 0 ||
                  Number(reimburseToEmployee) > 0)
              ? { status: "Pending Reimbursement" }
              : {}),

            ...(isEmpty(requisition?.By)
              ? {
                  By: values.By,
                  From: values.From,
                  postAmount: true,
                }
              : {
                  By: values.By,
                  From: values.From,
                }),
          },
          {
            onSuccess: () => {
              // console.log(requisition?.status, values);
              // This may be invalid now
              if (
                (values.paymentType === "Direct" ||
                  requisition?.paymentType === "Direct") &&
                [
                  "Approved & Closed",
                  "Pending Payment",
                  "Pending Reimbursement",
                  "Pending Retirement",
                  "",
                ].includes(requisition?.status)
              ) {
                raiseGRN(true);
              } else {
                refetch();
              }

              refetch();
            },
          }
        );
      }
    },
  });

  useEffect(() => {
    handlePurchaseRequestFormChanges({
      Vendor_ID: formik.values.Vendor_ID,
      invoiceNumber: formik.values.invoiceNumber,
    });
  }, [formik.values.Vendor_ID, formik.values.invoiceNumber]);

  // =============================================================

  const fetchSetUpData = async () => {
    let response = await fetch(`${backendUrl}/api/invoice/set-up`, {
      method: "GET",
      headers: {
        Accept: "Application/json",
        "Content-Type": "Application/json",
      },
      credentials: "include",
    });

    if (!response.ok) {
      response = await response.json();
      throw new Error(response.message);
    }

    const { data } = await response.json();

    data.vendors = [
      { label: "None", value: "" },
      ...data.vendors.map(el => ({
        ...el,
        label: `  ${el.CompanyName} / ${el.Vendor_ID}`,
        value: `  ${el.CompanyName} / ${el.Vendor_ID}`,
      })),
    ];

    data.banks = data?.banks
      .filter(
        el =>
          el?.BankName && el.currency === generalSettings?.prevailingCurrency
      )
      .map(el => ({
        ...el,
        label: `${el.BankName} ${el?.currency ? `(${el?.currency})` : `(NGN)`}`,
        value: el.BankName,
      }));

    data.branch = [
      {
        value: "General",
        label: "General",
      },
    ];

    data.imprest = data?.imprest
      .filter(el => el?.Description)
      .map(el => ({
        ...el,
        label: el?.Description,
        value: el?.Description,
      }));

    if (!isEmpty(data?.imprest)) {
    }
    return data;
  };

  const {
    data = { banks: [], vendors: [], branch: [], imprest: [] },
    isLoading,
  } = useQuery([queryActions.INVOICE_SETUP], () => fetchSetUpData(), {
    keepPreviousData: true,
  });

  const findVendor = Vendor_ID => {
    if (!Vendor_ID) return null;
    if (!data?.vendors) return Vendor_ID;

    const vendor = data.vendors.find(el => el.Vendor_ID === Vendor_ID);
    if (vendor) {
      return vendor?.label;
    } else {
      return Vendor_ID;
    }
  };

  const findStaff = Staff_ID => {
    if (!Staff_ID) return null;
    if (!allStaffs) return Staff_ID;

    const staff = allStaffs.find(el => el.Staff_ID === Staff_ID);
    if (staff) {
      return staff?.label;
    } else {
      return Staff_ID;
    }
  };

  const vendorsInTable = useMemo(
    () => tableData.map(el => el.Vendor_ID).filter(el => el),
    [tableData]
  );

  // ==============================================================

  const tableDataWithVendor = useMemo(() => {
    if (!data?.vendors) return [];

    // Create a Map for O(1) lookups
    const vendorMap = new Map(data.vendors.map(v => [v.Vendor_ID, v]));

    const records = cloneDeep(tableData).map(el => {
      const Vendor_ID =
        el.Vendor_ID && el.Vendor_ID !== " "
          ? el.Vendor_ID
          : formik.values.Vendor_ID;
      const invoiceNumber =
        el.invoiceNumber && el.invoiceNumber !== " "
          ? el.invoiceNumber
          : formik.values.invoiceNumber;

      const vendor = vendorMap.get(Vendor_ID);
      const vendorName = vendor?.label || Vendor_ID;

      return {
        ...el,
        invoiceNumber,
        Vendor_ID: Vendor_ID || "",
        vendorName,
        vendor: vendorName,
        Vendor: Vendor_ID || "",
        uniqueInvoiceAndVendor: `${invoiceNumber}-${Vendor_ID}`,
      };
    });

    return records;
  }, [
    tableData,
    formik.values.invoiceNumber,
    formik.values.Vendor_ID,
    data?.vendors,
  ]);

  const invoiceNumbersInTable = useMemo(
    () => uniqBy([...tableDataWithVendor], "uniqueInvoiceAndVendor"),
    [tableDataWithVendor]
  );

  // ===============================================================

  const raiseGRN = () => {
    const numberOfLines = tableData.length;
    const filledInvoices = tableData.filter(el => el.invoiceNumber).length;

    if (filledInvoices > 0 && numberOfLines !== filledInvoices) {
      return toast.error("Please enter Invoice Number in all items and save");
    }

    if (filledInvoices === 0 && !formik.values.invoiceNumber) {
      return toast.error("Enter Invoice Number to continue");
    }

    const filledVendors = tableData.filter(el => el.Vendor_ID).length;

    if (["Direct", "Pre-payment"].includes(formik.values.paymentType)) {
      if (filledVendors > 0 && numberOfLines !== filledVendors) {
        return toast.error("Please select Vendor in all items and save");
      }

      if (filledVendors === 0 && !formik.values.Vendor_ID) {
        return toast.error("Enter Select Vendor to continue");
      }

      if (
        filledVendors === 0 &&
        (isEmpty(formik.values.Vendor_ID) ||
          [null, "null"].includes(formik.values.Vendor_ID))
      ) {
        return toast.error("Please select the vendor");
      }
    }

    updateRequisitionMutation.mutate(
      {
        Vendor_ID: formik.values.Vendor_ID,
        vendor: formik.values.vendor,
        invoiceNumber: formik.values.invoiceNumber,
      },
      {
        onSuccess: () => {
          setRaiseGRN(true);
        },
      }
    );
  };

  const raiseGRNV2 = async ({ Vendor_ID, invoiceNumber }) => {
    let description = tableData
      .map(el => {
        delete el.subtotal;
        return Object.values(el).join(",,,");
      })
      .join("&&&");
    description = description + "&&&";

    const invoiceAndTaxValues = invoiceNumbersInTable.map((el, index) => {
      return (
        calculateVendorSubTotal({
          invoiceNumber: el.invoiceNumber,
          Vendor_ID: el.Vendor_ID,
        }) +
        calculateTax({
          taxTypeSelected: vendorTaxes?.find(
            vendorTax =>
              vendorTax.Vendor_ID === el.Vendor_ID &&
              vendorTax.invoiceNumber === el.invoiceNumber
          )?.taxType,
          invoiceAmount: calculateVendorSubTotal({
            invoiceNumber: el.invoiceNumber,
            Vendor_ID: el.Vendor_ID,
          }),
        })
      );
    });

    const realTotal = invoiceAndTaxValues.reduce(
      (a, b) =>
        currency(a, {
          precision: 2,
        }).add(b).value,
      0
    );

    updateRequisitionMutation.mutate(
      {
        Vendor_ID: formik.values.Vendor_ID,
        vendor: formik.values.vendor,
        invoiceNumber: formik.values.invoiceNumber,
        description,
        amount: isNaN(realTotal) ? 0 : realTotal,
        vendorTaxes: JSON.stringify(vendorTaxes),
      },
      {
        onSuccess: () => {
          setSelectedVendorToRaiseGRNFor({ Vendor_ID, invoiceNumber });
        },
      }
    );
  };

  const postPrepayment = () => {
    if (isEmpty(formik.values.By) || isEmpty(formik.values.From)) {
      return toast.error("Select Payment source");
    }

    if (
      isEmpty(formik.values.initialPrePayment) ||
      Number(formik.values.initialPrePayment) === 0
    ) {
      return toast.error("Enter Pre-payment amount");
    }

    if (isEmpty(formik.values.vendor) || isEmpty(formik.values.Vendor_ID)) {
      return toast.error("Select a Vendor");
    }

    /* if (isEmpty(formik.values.invoiceNumber)) {
      return toast.error("Enter Invoice Number");
    } */

    const payload = {
      initialPrePayment: formik.values.initialPrePayment,
      By: formik.values.By,
      From: formik.values.From,
      Vendor_ID: formik.values.Vendor_ID,
      vendor: formik.values.vendor,
      // invoiceNumber: formik.values.invoiceNumber,
      currencyCode: requisition.currency,
      conversionAmount: requisition.conversionAmount,
    };

    postPrePaymentMutation.mutate(payload);
  };

  const sendForApproval = () => {
    let values = cloneDeep(formik.values);
    if (
      values.paymentType !== "Direct" &&
      requisition?.initialAdvancePayment &&
      Number(values.amountExpensed) !==
        Number(requisition?.initialExpenseAmount) &&
      Number(total.value) !== Number(values.amountExpensed)
    ) {
      formik.setFieldTouched("amountExpensed", true);
      // await waitFor(200)
      const errorMessage =
        "Amount Expensed does not match items in requisition. \n Please adjust items to match";
      formik.setFieldError("amountExpensed", errorMessage);
      toast.error(errorMessage);
      console.log(amountExpensedRef);
    } else {
      setShowNewRequisitionModal(true);
    }
  };
  useEffect(() => {
    formik.setValues({
      initialAdvancePayment: requisition.initialAdvancePayment || 0,
      paymentType: requisition.paymentType,
      amountAdvanced: requisition.amountAdvanced || 0,
      amountExpensed: requisition.amountExpensed || 0,
      files: requisition?.files ? JSON.parse(requisition?.files) : [],
      By: requisition.By,
      From: requisition.From,
      requesterAccountName: requisition.requesterAccountName,
      requesterAccountNumber: requisition.requesterAccountNumber,
      requesterBank: requisition.requesterBank,
      //
      Vendor_ID: requisition?.Vendor_ID,
      vendor: requisition?.vendor,
      invoiceNumber: requisition?.invoiceNumber,
      initialPrePayment: requisition.initialPrePayment || 0,
    });
  }, [
    requisition?.initialAdvancePayment,
    requisition.paymentType,
    requisition.amountAdvanced,
    requisition.amountExpensed,
    requisition.files,
    requisition.By,
    requisition.From,
    requisition.requesterAccountName,
    requisition.requesterAccountNumber,
    requisition.requesterBank,
    // formik,
    requisition.Vendor_ID,
    requisition.vendor,
    requisition.invoiceNumber,
    requisition.initialPrePayment || 0,
  ]);

  const reimburseToCompany = useMemo(() => {
    return Number(formik.values.amountAdvanced) >
      Number(formik.values.amountExpensed)
      ? currency(formik.values.amountAdvanced).subtract(
          formik.values.amountExpensed
        ).value
      : 0;
  }, [formik.values.amountAdvanced, formik.values.amountExpensed]);

  const reimburseToEmployee = useMemo(() => {
    return Number(formik.values.amountExpensed) >
      Number(formik.values.amountAdvanced)
      ? currency(formik.values.amountExpensed).subtract(
          formik.values.amountAdvanced
        ).value
      : 0;
  }, [formik.values.amountAdvanced, formik.values.amountExpensed]);

  const handlePaymentMethod = value => {
    formik.setFieldValue("By", value);
    formik.setFieldValue("From", "");
  };

  // const handlePaymentMethodReimburse = value => {
  //   formik.setFieldValue("reimburseByBy", value);
  //   formik.setFieldValue("reimburseByFrom", "");
  // };

  const resolveFromOptions = PaymentType => {
    // console.log(PaymentType, data.banks);
    return PaymentType === "Imprest"
      ? data.imprest
      : ["Cheque", "Direct Bank Transfer", "Credit/Debit Card"].includes(
          PaymentType
        )
      ? data.banks
      : cashOptions;
  };

  const closeOut = async () => {
    const reimburseTo =
      reimburseToCompany > reimburseToEmployee ? "Company" : "Staff";
    const formValues = await PaymentAccountDialog({
      data,
      previouslySelectedAccount: {
        By: requisition?.By,
        From: requisition?.From,

        // Remove amount that was settled in payroll generation
        amount: currency(
          reimburseTo === "Company" ? reimburseToCompany : reimburseToEmployee
        ).subtract(requisition?.settledAmount).value,
        reimburseTo,
      },
    });

    if (formValues) {
      //  console.log(formValues);

      closeOutMutation.mutate(
        {
          ...formValues,
          reimburseTo,
          subStatus: "Closed Out",
        },
        {
          onSuccess: ({ message }) => {
            toast.success("Closed Out");
            refetch();
          },
        }
      );
    }
  };

  const retire = async () => {
    formik.setFieldValue("retireNow", true);
    if (
      await ConfirmDialog({
        title: "Retirement",
        description: "Are you sure you want to save?",
      })
    ) {
      formik.submitForm();
    } else {
      formik.setFieldValue("retireNow", false);
    }
  };

  const hasAnyMandatoryUserApproved = requisition => {
    // if requisition has already been final approved just allow
    const alreadyHasFinalApproval = requisition?.requisitiontracks?.find(
      track => track.closedHere
    );
    if (alreadyHasFinalApproval) {
      return true;
    }

    let permissions = JSON.parse(requisition.requiredSignatoriesStaff_ID);

    permissions.push(
      ...(generalSettings?.secondLineFundRequestApproval
        ? generalSettings.secondLineFundRequestApproval
        : [])
    );

    const usersInTracks = requisition?.requisitiontracks
      ? requisition?.requisitiontracks
          .filter(
            el => !["pending", "disapproved"].includes(lowerCase(el.status))
          )
          ?.map(el =>
            [el.sentbyUser?.Staff_ID, el.receivedbyUser?.Staff_ID].filter(
              el => el
            )
          ) //  Remove  Sender

          .flat()
          .filter(el => el !== requisition.requestby)
      : [];

    const foundRequiredSignatory = permissions?.find(el =>
      usersInTracks.includes(el.staff)
    );

    return foundRequiredSignatory;
  };

  const undoPaymentAPI = async payload => {
    let response = await fetch(
      `${backendUrl}/api/requisition/undo-payment/${requisition.requestid}`,
      {
        method: "POST",
        credentials: "include",
        body: JSON.stringify(payload),
        headers: {
          Accept: "Application/json",
          "Content-Type": "Application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (!response.ok) {
      response = await response.json();
      throw new Error(response.message);
    }
    const res = await response.json();
    return res;
  };
  const undoPaymentMutation = useMutation(payload => undoPaymentAPI(payload), {
    onSuccess: ({ message }) => {
      toast.success(message);
      refetch();
    },
    onError: ({ message = "" }) => {
      toast.error(`Unable to perform action: ${message}`);
    },
  });

  // const undoPostedPayment = async () => {
  //   if (
  //     await ConfirmDialog({
  //       title: "Undo Payment",
  //       description:
  //         "All Previous Payment and Retirement data will be cleared.",
  //       type: "danger",
  //     })
  //   ) {
  //     undoPaymentMutation.mutate(requisition);
  //   }
  // };

  const onGRNPosted = async () => {
    if (!isCashier) return;
    if (requisition.paymentType !== "Direct") return;

    const action = await ConfirmPostPurchasePaymentDialog({
      title: "Post Purchase Payment",
      description: "Are you sure you want to post this purchase payment?",
    });

    if (action && action?.mode === "Pay now") {
      navigate(
        `/vendor/post-vendors-payment?InvoiceNo=${formik.values.invoiceNumber}`,
        {
          state: {
            vendorToPay: {
              Vendor_ID: formik.values.Vendor_ID,
              label: formik.values.vendor,
              value: formik.values.Vendor_ID,
            },
            TransactionID: formik.values.invoiceNumber,
          },
        }
      );
    }
  };

  const payVendorPage = ({ invoiceNumber, Vendor_ID, vendor }) => {
    // Raise GRN first

    return navigate(`/vendor/post-vendors-payment`, {
      state: {
        vendorToPay: {
          Vendor_ID,
          label: vendor,
          value: Vendor_ID,
        },
        TransactionID: invoiceNumber,
        requestid: requisition.requestid,
      },
    });
  };

  const calculateTax = ({ taxTypeSelected = "", invoiceAmount = 0 }) => {
    if (!taxTypeSelected) return 0;
    const taxType = taxOptions.find(el => el.value === taxTypeSelected);
    return currency(invoiceAmount).multiply(taxType?.percentage).value;
  };

  const calculateVendorSubTotal = ({ invoiceNumber, Vendor_ID }) => {
    const total = tableDataWithVendor
      .filter(
        item =>
          item.invoiceNumber === invoiceNumber && item.Vendor_ID === Vendor_ID
      )
      .map(el => currency(el.unitCost).multiply(el.quantity).value)
      .reduce((a, b) => currency(a).add(b).value, 0);

    return total;
  };

  const postAdvancePaymentData = async payload => {
    let response = await fetch(`${backendUrl}/api/invexcloud/pay-advance`, {
      method: "POST",
      credentials: "include",
      body: JSON.stringify(payload),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!response.ok) {
      response = await response.json();
      throw new Error(response.message);
    }
    const res = await response.json();
    return res;
  };

  const postAdvancePaymentMutation = useMutation(
    payload => postAdvancePaymentData(payload),
    {
      onSuccess: ({ message }) => {
        toast.success(message);
        refetch();
      },
      onError: ({ message = "" }) => {
        toast.error(`Unable to perform action: ${message}`);
      },
    }
  );

  const payAdvance = async ({
    Vendor_ID,
    invoiceNumber,
    Staff_ID_To_Advance,
  }) => {
    const amount = currency(
      calculateVendorSubTotal({
        invoiceNumber,
        Vendor_ID,
      }) +
        calculateTax({
          taxTypeSelected: vendorTaxes?.find(
            vendorTax =>
              vendorTax.Vendor_ID === Vendor_ID &&
              vendorTax.invoiceNumber === invoiceNumber
          )?.taxType,
          invoiceAmount: calculateVendorSubTotal({
            invoiceNumber,
            Vendor_ID,
          }),
        })
    ).value;

    const action = await PaymentAccountDialog({
      data,
      previouslySelectedAccount: {
        By: "",
        From: "",
        amount,
      },
      payFromLabel: "From",
      payByLabel: "By",
    });

    if (action) {
      const payload = {
        ...action,
        Vendor_ID,
        invoiceNumber,
        Staff_ID_To_Advance,
        amount,
        From: action.reimburseFrom,
        requestid: requisition.requestid,
        By: action.reimburseBy,
      };

      postAdvancePaymentMutation.mutate(payload);
    }
  };

  const paymentsFromJournal = useMemo(() => {
    if (expensedAccounts) return [];
    return expensedAccounts?.filter(
      el => el.TransID && el?.AccountID === "CASH AND CASH EQUIVALENT"
    );
  }, [expensedAccounts]);

  const findRaisedGRN = invoiceNumber => {
    return raisedGRNs?.find(grn => grn.InvoiceNo === invoiceNumber);
  };

  return (
    <>
      <Form
        noValidate
        onSubmit={formik.handleSubmit}
        autoComplete="off"
        className="p-3 my-4 border"
      >
        <Table borderless className="upsert-table">
          <tbody>
            <tr>
              <td colSpan={2}>
                <p>If Approved, purchases should be paid to</p>
              </td>
            </tr>
            <tr>
              <td className="fw-bold  text-right">Account Name:</td>
              <td>
                <Form.Control
                  placeholder="Enter Account Name"
                  name="requesterAccountName"
                  value={formik.values.requesterAccountName}
                  onChange={formik.handleChange}
                />
              </td>
            </tr>
            <tr>
              <td className="fw-bold  text-right">Account Number:</td>
              <td>
                <Form.Control
                  placeholder="Enter Account Number"
                  name="requesterAccountNumber"
                  value={formik.values.requesterAccountNumber}
                  onChange={formik.handleChange}
                />
              </td>
            </tr>
            <tr>
              <td className="fw-bold  text-right">Bank:</td>
              <td>
                <Form.Control
                  placeholder="Enter Bank"
                  name="requesterBank"
                  value={formik.values.requesterBank}
                  onChange={formik.handleChange}
                />
              </td>
            </tr>
            {/* <tr>
              <td colSpan={2}>
                <hr />
              </td>
            </tr>
            <tr>
              <td className="fw-bold  text-right">Initial Total</td>
              <td>
                <CurrencyCustomInput
                  currencySymbol={currencySymbol}
                  value={requisition?.initialExpenseAmount}
                  readOnly
                />
              </td>
            </tr> */}
            {/*  <tr>
              <td className="fw-bold  text-right">Payment Type</td>
              <td>
                <div className="d-flex gap-3 h-auto">
                  <div className="flex-grow-1">
                    <Select
                      classNamePrefix={`form-select`}
                      options={paymentTypesForPurchaseRequest}
                      value={paymentTypesForPurchaseRequest.find(
                        el => el.value === formik.values.paymentType
                      )}
                      onChange={selected => formik.setFieldValue("paymentType", selected?.value)}
                      isDisabled={!isCashier || requisition?.paymentType}
                    />
                    {formik.touched.paymentType && formik.errors.paymentType ? (
                      <span className="text-danger mt-2">{formik.errors.paymentType}</span>
                    ) : null}
                  </div>
                </div>
              </td>
            </tr> */}
            {formik.values.paymentType === "Direct" && (
              <>
                <tr>
                  <td className="fw-bold  text-right">Attachments</td>
                  <td>
                    <Attachments
                      files={formik.values.files}
                      setFiles={files => formik.setFieldValue("files", files)}
                    />
                  </td>
                </tr>
              </>
            )}

            {formik.values.paymentType === "Advance" ? (
              <>
                <tr>
                  <td className="fw-bold  text-right">
                    {requisition?.initialAdvancePayment &&
                    requisition?.paymentType === "Advance"
                      ? "Initial Advanced Amount "
                      : `Advanced Amount `}{" "}
                  </td>
                  <td>
                    <CurrencyCustomInput
                      currencySymbol={currencySymbol}
                      readOnly={!isCashier}
                      name="initialAdvancePayment"
                      placeholder="0.00"
                      value={formik.values.initialAdvancePayment}
                      onValueChange={(value, name) => {
                        formik.setFieldValue(name, value);
                      }}
                    />
                    {formik.touched.initialAdvancePayment &&
                    !!formik.errors.initialAdvancePayment ? (
                      <span className="custom-invalid-feedback">
                        {formik.errors.initialAdvancePayment}
                      </span>
                    ) : null}
                  </td>
                </tr>
                <tr>
                  <td>
                    <div style={{ width: "15rem" }}>
                      <Form.Group>
                        <Form.Label className="fw-bold ">Pay By</Form.Label>
                        <Select
                          classNamePrefix="form-select"
                          menuPlacement="top"
                          placeholder="Choose method"
                          isSearchable={false}
                          value={paymentMethod.find(
                            el => el.value === formik.values.By
                          )}
                          options={paymentMethod}
                          onChange={({ value }) => handlePaymentMethod(value)}
                          getOptionLabel={el => (
                            <div className="label-with-icon d-flex gap-2 align-items-center">
                              <span>{el.icon}</span>{" "}
                              <span className="fw-5">{el.label}</span>
                            </div>
                          )}
                          // Already Picked a method -------
                          isDisabled={requisition?.paymentType}
                        />
                        {formik.touched.By && !!formik.errors.By ? (
                          <span className="custom-invalid-feedback">
                            {formik.errors.By}
                          </span>
                        ) : null}
                      </Form.Group>
                    </div>
                  </td>
                  <td>
                    <Form.Group>
                      <Form.Label className="fw-bold ">Pay From</Form.Label>
                      <Select
                        classNamePrefix="form-select"
                        value={resolveFromOptions(formik.values.By).find(
                          el => el.value === formik.values.From
                        )}
                        options={resolveFromOptions(formik.values.By)}
                        onChange={({ value }) =>
                          formik.setFieldValue("From", value)
                        }
                        key={formik.values?.By}
                        // Already Picked a method -------
                        isDisabled={requisition?.paymentType}
                      />
                      {formik.touched.From && !!formik.errors.From ? (
                        <span className="custom-invalid-feedback">
                          {formik.errors.From}
                        </span>
                      ) : null}
                    </Form.Group>
                  </td>
                </tr>
              </>
            ) : null}

            {formik.values.paymentType === "Pre-payment" ? (
              <>
                <tr>
                  <td className="fw-bold text-right">
                    {requisition?.initialPrePayment &&
                    requisition?.paymentType === "Pre-payment"
                      ? "Initial Pre-payment Amount "
                      : `Pre-payment Amount `}{" "}
                  </td>
                  <td>
                    <CurrencyCustomInput
                      currencySymbol={currencySymbol}
                      readOnly={!isCashier}
                      name="initialPrePayment"
                      placeholder="0.00"
                      value={formik.values.initialPrePayment}
                      onValueChange={(value, name) => {
                        formik.setFieldValue(name, value);
                      }}
                      disabled={requisition?.paymentType}
                    />
                    {formik.touched.initialPrePayment &&
                    !!formik.errors.initialPrePayment ? (
                      <span className="custom-invalid-feedback">
                        {formik.errors.initialPrePayment}
                      </span>
                    ) : null}
                  </td>
                </tr>
                <tr>
                  <td>
                    <div style={{ width: "15rem" }}>
                      <Form.Group>
                        <Form.Label className="fw-bold ">Pay By</Form.Label>
                        <Select
                          classNamePrefix="form-select"
                          menuPlacement="top"
                          placeholder="Choose method"
                          isSearchable={false}
                          value={paymentMethod.find(
                            el => el.value === formik.values.By
                          )}
                          options={paymentMethod}
                          onChange={({ value }) => handlePaymentMethod(value)}
                          getOptionLabel={el => (
                            <div className="label-with-icon d-flex gap-2 align-items-center">
                              <span>{el.icon}</span>{" "}
                              <span className="fw-5">{el.label}</span>
                            </div>
                          )}
                          // Already Picked a method -------
                          isDisabled={requisition?.paymentType}
                        />
                        {formik.touched.By && !!formik.errors.By ? (
                          <span className="custom-invalid-feedback">
                            {formik.errors.By}
                          </span>
                        ) : null}
                      </Form.Group>
                    </div>
                  </td>
                  <td>
                    <Form.Group>
                      <Form.Label className="fw-bold ">Pay From</Form.Label>
                      <Select
                        classNamePrefix="form-select"
                        value={resolveFromOptions(formik.values.By).find(
                          el => el.value === formik.values.From
                        )}
                        options={resolveFromOptions(formik.values.By)}
                        onChange={({ value }) =>
                          formik.setFieldValue("From", value)
                        }
                        key={formik.values?.By}
                        // Already Picked a method -------
                        isDisabled={requisition?.paymentType}
                      />
                      {formik.touched.From && !!formik.errors.From ? (
                        <span className="custom-invalid-feedback">
                          {formik.errors.From}
                        </span>
                      ) : null}
                    </Form.Group>
                  </td>
                </tr>
              </>
            ) : null}

            {formik?.values.paymentType === "Direct" ||
            formik?.values.paymentType === "Pre-payment" ? (
              <>
                {/* Needs Vendor */}

                <>
                  {isEmpty(vendorsInTable) ? (
                    <tr>
                      <td className="fw-bold  text-right">Vendor</td>
                      <td>
                        <Select
                          classNamePrefix={"form-select"}
                          name="vendor"
                          options={data?.vendors}
                          value={data?.vendors?.find(
                            el =>
                              formik.values.Vendor_ID &&
                              el.value === formik.values.vendor
                          )}
                          onChange={selected => {
                            formik.setFieldValue("vendor", selected?.value);
                            formik.setFieldValue(
                              "Vendor_ID",
                              selected?.Vendor_ID
                            );
                          }}
                        />
                      </td>
                    </tr>
                  ) : null}

                  {/* Invoice Number / Ref */}
                  {isEmpty(invoiceNumbersInTable) ? (
                    <tr>
                      <td className="fw-bold  text-right">
                        Invoice Number / Ref
                      </td>
                      <td>
                        <Form.Control
                          placeholder="Enter Invoice Number"
                          name="invoiceNumber"
                          value={formik.values.invoiceNumber}
                          onChange={formik.handleChange}
                        />
                      </td>
                    </tr>
                  ) : null}
                </>
              </>
            ) : null}

            {requisition?.paymentType === "Advance" ? (
              <>
                <tr>
                  <td colSpan={2}>
                    <hr />
                  </td>
                </tr>
                <tr>
                  <td colSpan={2}>
                    <h2>Retirement</h2>
                  </td>
                </tr>
                <tr>
                  <td className="fw-bold  text-right">Amount Advanced</td>
                  <td>
                    <CurrencyCustomInput
                      currencySymbol={currencySymbol}
                      readOnly={true}
                      name="amountAdvanced"
                      placeholder="0.00"
                      value={formik.values.amountAdvanced}
                      onValueChange={(value, name) => {
                        formik.setFieldValue(name, value);
                      }}
                    />
                  </td>
                </tr>
                <tr>
                  <td className="fw-bold  text-right">Amount Expensed</td>
                  <td>
                    <CurrencyCustomInput
                      currencySymbol={currencySymbol}
                      readOnly={authUser.Staff_ID !== requisition?.requestby}
                      name="amountExpensed"
                      placeholder="0.00"
                      value={formik.values.amountExpensed}
                      onValueChange={(value, name) => {
                        formik.setFieldValue(name, value);
                      }}
                      disabled={attachedRequest}
                      ref={amountExpensedRef}
                    />
                    {formik.touched.amountExpensed &&
                    !!formik.errors.amountExpensed ? (
                      <span
                        className="custom-invalid-feedback  d-block mt-1"
                        style={{ width: "16rem" }}
                      >
                        {formik.errors.amountExpensed}
                      </span>
                    ) : null}
                  </td>
                </tr>
                <tr>
                  <td className="fw-bold  text-right">
                    Amount Reimbursable to Company
                  </td>
                  <td>
                    <CurrencyCustomInput
                      currencySymbol={currencySymbol}
                      readOnly
                      value={reimburseToCompany}
                    />
                  </td>
                </tr>
                <tr>
                  <td className="fw-bold  text-right">
                    Amount Reimbursable to Employee
                  </td>
                  <td>
                    <CurrencyCustomInput
                      currencySymbol={currencySymbol}
                      readOnly
                      value={reimburseToEmployee}
                    />
                  </td>
                </tr>

                {attachedRequest?.requestid && (
                  <tr>
                    <td className="fw-bold  text-right">
                      Invoice Number / Ref
                    </td>
                    <td>
                      <Form.Control
                        placeholder="Enter Invoice Number"
                        name="invoiceNumber"
                        value={formik.values.invoiceNumber}
                        onChange={formik.handleChange}
                      />
                    </td>
                  </tr>
                )}

                <tr>
                  <td className="fw-bold  text-right">Attachments</td>
                  <td>
                    <Attachments
                      files={formik.values.files}
                      setFiles={files => formik.setFieldValue("files", files)}
                    />
                  </td>
                </tr>
                {requisition?.retirementDate ? (
                  <tr>
                    <td className="fw-bold  text-right">Retirement Date</td>
                    <td>{formatDate(requisition?.retirementDate)}</td>
                  </tr>
                ) : null}
                {requisition?.reimbursementDueDate &&
                requisition.reimburseToCompany ? (
                  <tr>
                    <td className="fw-bold  text-right">
                      Reimbursement Due Date
                    </td>
                    <td className="d-flex gap-3">
                      <span className="text-nowrap">
                        {" "}
                        {formatDate(requisition?.reimbursementDueDate)}{" "}
                      </span>
                      {requisition?.subStatus && (
                        <ApprovalBadge
                          text={requisition.subStatus}
                          className="approval"
                          bg={resolveApprovalBadgeBg(requisition.subStatus)}
                        />
                      )}
                      {requisition?.settledAmount &&
                      Number(requisition?.settledAmount) > 0 ? (
                        <i>
                          {currency(requisition?.settledAmount, {
                            symbol: "",
                          }).format()}{" "}
                          was settled from Payroll
                        </i>
                      ) : null}
                    </td>
                  </tr>
                ) : null}
              </>
            ) : null}
          </tbody>
        </Table>

        <div className="d-flex gap-3">
          {isEmpty(requisition?.paymentType) &&
          isCashier &&
          hasAnyMandatoryUserApproved(requisition) ? (
            <>
              {formik.values.paymentType === "Pre-payment" ? (
                <Button
                  variant="primary"
                  className=""
                  type="button"
                  onClick={() => postPrepayment()}
                >
                  Post Pre-payment
                </Button>
              ) : (
                <>
                  {/*  <Button variant="primary" className="" type="submit">
                    {formik.values.paymentType === "Direct" ? "Authorize." : "Save"}
                  </Button> */}
                </>
              )}
            </>
          ) : null}

          {!hasAnyMandatoryUserApproved(requisition) && (
            <i>No Mandory Signatory has Approved</i>
          )}

          <>
            {requisition.paymentType === "Direct" && (
              <>
                {isCashier &&
                requisition?.status !== "Approved & Closed - Paid" &&
                hasAnyMandatoryUserApproved(requisition) ? (
                  <>
                    {!requisition.isGRNRaisedForPurchase ? (
                      {
                        /*  <Button
                        variant="primary"
                        className=""
                        type="button"
                        onClick={() => raiseGRN(true)}
                      >
                        Raise GRN
                      </Button> */
                      }
                    ) : (
                      <>
                        {/*  <div className="d-flex gap-2 align-items-center">
                        <b className="text-success">GRN Raised</b>
                        <a
                          className="btn btn-light-blue"
                          href={`${backendUrl}/api/invexcloud/pdf/grn/${requisition.invoiceNumber}`}
                          target="_blank"
                        >
                          <RecieptIcon />
                          Print GRN
                        </a>
                      </div> */}
                      </>
                    )}
                  </>
                ) : requisition?.status === "Pending" && isCashier ? (
                  <Button variant="primary" className="" type="submit">
                    Authorize
                  </Button>
                ) : null}
              </>
            )}
          </>

          {/*   */}
          {requisition.paymentType === "Advance" && (
            <>
              {/* Creator  */}
              {requisition?.initialAdvancePayment &&
              authUser.Staff_ID === requisition?.requestby &&
              !["Approved & Closed", "Approved & Closed - Paid"].includes(
                requisition?.status
              ) &&
              !requisition?.settledAmount ? (
                <>
                  {!attachedRequest ? (
                    <Button
                      variant="primary"
                      className=""
                      type="button"
                      title={authUser.Staff_ID}
                      onClick={() => {
                        sendForApproval();
                      }}
                    >
                      Send for Approval
                    </Button>
                  ) : null}
                </>
              ) : null}
              {/* Cashier  */}
              {isCashier &&
              requisition?.retirementDate !== null &&
              requisition?.subStatus !== "Closed Out" ? (
                <Button
                  variant="light-blue"
                  className=""
                  type="button"
                  onClick={() => closeOut()}
                >
                  Close Out
                </Button>
              ) : null}

              {isCashier &&
              requisition?.status !== "Approved & Closed - Paid" &&
              requisition?.status !== "Approved & Closed - Retired" &&
              hasAnyMandatoryUserApproved(requisition) &&
              requisition?.retirementDate !== null ? (
                <>
                  {!requisition.isGRNRaisedForPurchase ? (
                    {
                      /*  <Button
                      variant="primary"
                      className=""
                      type="button"
                      onClick={() => raiseGRN(true)}
                    >
                      Raise GRN
                    </Button> */
                    }
                  ) : (
                    <>
                      {/*  <div className="d-flex gap-2 align-items-center">
                      <b className="text-success">GRN Raised</b>
                      <a
                        className="btn btn-light-blue"
                        href={`${backendUrl}/api/invexcloud/pdf/grn/${requisition.invoiceNumber}`}
                        target="_blank"
                      >
                        <RecieptIcon />
                        Print GRN
                      </a>
                    </div> */}
                    </>
                  )}
                </>
              ) : null}
            </>
          )}

          {/*   */}
          {requisition.paymentType === "Pre-payment" && (
            <>
              {isCashier &&
              requisition?.status !== "Approved & Closed - Paid" &&
              requisition?.status !== "Approved & Closed - Retired" &&
              /*  requisition?.status !== "Approved & Closed - GRN Raised" && */
              hasAnyMandatoryUserApproved(requisition) ? (
                <>
                  {!requisition.isGRNRaisedForPurchase ? (
                    {
                      /* <Button
                      variant="primary"
                      className=""
                      type="button"
                      onClick={() => raiseGRN(true)}
                    >
                      Raise GRN
                    </Button> */
                    }
                  ) : (
                    <>
                      {/*  <div className="d-flex gap-2 align-items-center">
                      <b className="text-success">GRN Raised</b>
                      <a
                        className="btn btn-light-blue"
                        href={`${backendUrl}/api/invexcloud/pdf/grn/${requisition.invoiceNumber}`}
                        target="_blank"
                      >
                        <RecieptIcon />
                        Print GRN
                      </a>
                    </div>  */}
                    </>
                  )}
                </>
              ) : null}
            </>
          )}
        </div>

        {/*  <Button
          onClick={() =>
            navigate(`/vendor/post-vendors-payment?InvoiceNo=${formik.values.invoiceNumber}`, {
              state: {
                vendorToPay: {
                  Vendor_ID: formik.values.Vendor_ID,
                  label: formik.values.vendor,
                  value: formik.values.Vendor_ID,
                },
                TransactionID: formik.values.invoiceNumber,
              },
            })
          }
        >
          ...
        </Button> */}
        <hr />

        {/*  Raise GRN  */}
        <Table borderless className="upsert-table">
          <tbody>
            <tr>
              <td className="fw-bold  text-right">Vendor</td>
              <td>
                <Select
                  classNamePrefix={"form-select"}
                  name="vendor"
                  options={data?.vendors}
                  value={data?.vendors?.find(
                    el =>
                      formik.values.Vendor_ID &&
                      el.value === formik.values.vendor
                  )}
                  onChange={selected => {
                    formik.setFieldValue("vendor", selected?.value);
                    formik.setFieldValue("Vendor_ID", selected?.Vendor_ID);
                  }}
                />
              </td>
            </tr>

            {/* Invoice Number / Ref */}

            <tr>
              <td className="fw-bold  text-right">Invoice Number / Ref</td>
              <td>
                <Form.Control
                  placeholder="Enter Invoice Number"
                  name="invoiceNumber"
                  value={formik.values.invoiceNumber}
                  onChange={formik.handleChange}
                />
              </td>
            </tr>
          </tbody>
        </Table>

        {/*  GRNS */}
        {requisition.requisitiontracks.find(el => el?.closedHere) ? (
          <div className="w-100">
            <div className="row g-3">
              {invoiceNumbersInTable.map((el, index) => (
                <div
                  key={index}
                  className="col-4 p-3 border rounded position-relative d-flex flex-column gap-2"
                  style={{ fontWeight: "400 !important" }}
                >
                  {/* GRN MUST BE RAISE FIRST BEFORE THE DROPDOWN WILL BE AVAILABLE */}
                  {el?.invoiceNumber && findRaisedGRN(el?.invoiceNumber) ? (
                    <div className="position-absolute top-0 end-0 p-3">
                      <AfterGRNRaisedDropdown
                        invoiceNumber={el?.invoiceNumber}
                        refetch={refetch}
                      />
                    </div>
                  ) : null}

                  <span>
                    <b>Vendor:</b>{" "}
                    {el.Vendor_ID ? (
                      <span>{findVendor(el.Vendor_ID)}</span>
                    ) : (
                      <span className="text-danger">No Vendor Selected</span>
                    )}
                  </span>

                  <span>
                    <b>Invoice Number / Ref:</b>{" "}
                    {el?.invoiceNumber ? (
                      <span>{el.invoiceNumber}</span>
                    ) : (
                      <span className="text-danger">
                        No Invoice Number Entered
                      </span>
                    )}
                  </span>

                  {/* <p>
                    <b>Staff To Advance:</b>{" "}
                    {el?.Staff_ID_To_Advance ? (
                      <span>{findStaff(el.Staff_ID_To_Advance)}</span>
                    ) : (
                      <span className="text-danger">No Staff Selected</span>
                    )}
                  </p> */}

                  <span>
                    <b>Total Invoice Amount:</b>{" "}
                    {currency(
                      calculateVendorSubTotal({
                        invoiceNumber: el.invoiceNumber,
                        Vendor_ID: el.Vendor_ID,
                      }) +
                        calculateTax({
                          taxTypeSelected: vendorTaxes?.find(
                            vendorTax =>
                              vendorTax.Vendor_ID === el.Vendor_ID &&
                              vendorTax.invoiceNumber === el.invoiceNumber
                          )?.taxType,
                          invoiceAmount: calculateVendorSubTotal({
                            invoiceNumber: el.invoiceNumber,
                            Vendor_ID: el.Vendor_ID,
                          }),
                        }),
                      {
                        symbol: currencySymbol,
                      }
                    ).format()}
                  </span>

                  <div className="d-flex gap-3 align-items-center mt-3">
                    {/* WHEN GRN HAS NOT BEEN RAISED */}
                    {!findRaisedGRN(el?.invoiceNumber) ? (
                      <>
                        <Button
                          variant="light-blue"
                          className="btn-sm border"
                          disabled={
                            isEmpty(el.Vendor_ID) ||
                            isEmpty(el.invoiceNumber?.trim())
                          }
                          onClick={() =>
                            raiseGRNV2({
                              Vendor_ID: el.Vendor_ID,
                              invoiceNumber: el.invoiceNumber,
                            })
                          }
                        >
                          <RecieptIcon /> Raise GRN
                        </Button>

                        {/* GRN has not been raised yet */}
                        {/* Check if staff is chosen else we pay advance to vendor  */}
                        {(isCashier || isAdmin) &&
                        !paymentsFromJournal.find(
                          payment => payment.TransID === el.invoiceNumber
                        ) ? (
                          <>
                            {/* <Button
                              variant="light-blue"
                              className="border"
                              //  disabled={isEmpty(el.invoiceNumber?.trim())}
                              onClick={() => payAdvance(el)}
                            >
                              <FaMoneyBillAlt /> Pay Advance
                            </Button> */}
                          </>
                        ) : null}

                        {/*  Retirement  */}

                        {/*  */}
                        {paymentsFromJournal.find(
                          payment => payment.TransID === el.invoiceNumber
                        ) ? (
                          <div className="text-success position-absolute top-0 end-0 p-3">
                            <b>Paid</b>
                          </div>
                        ) : null}
                      </>
                    ) : (
                      <>
                        <b className="text-success btn border-lighter">
                          ✓&nbsp;GRN Raised {/* MIGHT REQUIRE UI WORK */}
                          {/* {findRaisedGRN(el?.invoiceNumber)?.Status ===
                          "CONFIRMED" ? (
                            <>and Confirmed</>
                          ) : null} */}
                        </b>

                        {/* WHEN GRN HAS BEEN PAIDED */}
                        {findRaisedGRN(el?.invoiceNumber)?.hasPaid ? (
                          <div className="text-success btn border-lighter">
                            ✓&nbsp;<b>Paid</b>
                          </div>
                        ) : null}

                        <a
                          className="btn btn-light-blue border"
                          href={`${backendUrl}/api/invexcloud/pdf/grn/${
                            el.invoiceNumber
                          }`}
                          target="_blank"
                          title="Print GRN"
                        >
                          <PrintIcon />
                          {"  "}
                          Print GRN
                        </a>

                        {/* GRN MUST BE RAISED BEFORE PAYMENT */}
                        {/* IF NOT PAID THEN */}
                        {!findRaisedGRN(el?.invoiceNumber)?.hasPaid ? (
                          <>
                            {isCashier || isAdmin ? (
                              <Button
                                variant="outline-primary"
                                /* DETAILS MUST BE AVAILABLE */
                                disabled={
                                  isEmpty(el.Vendor_ID) ||
                                  isEmpty(el.invoiceNumber?.trim())
                                }
                                onClick={() => payVendorPage(el)}
                                title="Pay Vendor"
                              >
                                <FaMoneyBillAlt /> Pay Vendor
                              </Button>
                            ) : null}
                          </>
                        ) : null}
                      </>
                    )}

                    {/* TODO:  Retirement  */}

                    {/*  ----------- */}
                  </div>
                </div>
              ))}
            </div>
          </div>
        ) : null}

        {attachedRequest && (
          <div className="py-3 border-bottom my-3">
            <p>Retirement Request</p>
            <div className="d-flex gap-3 align-items-center">
              <Link
                to={requisitionLink(attachedRequest.requestid)}
                target="_blank"
                className="btn btn-light-blue"
              >
                <EyeOutlineIcon /> View Retirement Request
              </Link>
              <ApprovalBadge
                text={attachedRequest?.status}
                className="approval"
                bg={resolveApprovalBadgeBg(attachedRequest?.status)}
              />

              {isCashier &&
              attachedRequest?.status.includes("Approved & Closed") &&
              requisition?.retirementDate == null ? (
                <Button
                  variant="primary"
                  className=""
                  type="button"
                  title={authUser.Staff_ID}
                  onClick={() => retire()}
                >
                  Confrirm Retirement
                </Button>
              ) : null}
            </div>
          </div>
        )}

        {!isEmpty(expensedAccounts) && (isAdmin || isCashier) ? (
          <Table responsive borderless striped className="product-table my-3">
            <thead>
              <tr className="bg-white">
                <th colSpan={5}>Account Postings</th>
              </tr>
              <tr>
                <th>Trans Date</th>
                <th>Account Type</th>
                <th>Account</th>
                <th>Debit</th>
                <th>Credit</th>
              </tr>
            </thead>
            <tbody>
              {expensedAccounts
                ?.filter(el => el.Debit || el.Credit)
                .map((el, index) => (
                  <tr key={index}>
                    <td className="text-nowrap">
                      {el?.DateLog
                        ? formatDate(el.DateLog, "dd MMM yyyy")
                        : "..."}
                    </td>
                    <td title={el.TransID}>{el.AccountID}</td>
                    <td>{el.Description}</td>
                    <td>
                      {el.currency &&
                      requisition?.currency &&
                      requisition?.currency !==
                        generalSettings?.prevailingCurrency
                        ? currency(el.Debit, {
                            symbol: currencySymbol,
                          })
                            .divide(el.conversionAmount)
                            .format()
                        : currency(el.Debit, {
                            symbol: currencySymbol,
                          }).format()}
                    </td>
                    <td>
                      {el.currency &&
                      requisition?.currency &&
                      requisition?.currency !==
                        generalSettings?.prevailingCurrency
                        ? currency(el.Credit, {
                            symbol: currencySymbol,
                          })
                            .divide(el.conversionAmount)
                            .format()
                        : currency(el.Credit, {
                            symbol: currencySymbol,
                          }).format()}
                    </td>
                  </tr>
                ))}
            </tbody>
          </Table>
        ) : null}
      </Form>

      {showNewRequisitionModal && requisition?.title ? (
        <NewRequisitionModal
          modalTitle="Send for Approval"
          defaultFormValues={{
            title: `Retirement: ${requisition?.title}`,
            description: ``,
            type: "Retirement for Purchase Request",
            cost: 0,
            vendor: requisition?.vendor || " ",
            jobNumber: "",
            poNumber: "", // GA
            recipient: "",
            attachedRequestid: requisition.requestid,
            preSelectedSignatory: [
              {
                staff: requisition.requestbyUser.Staff_ID,
                staffName: requisition.requestbyUser.Name,
                Name: requisition.requestbyUser.Name,
                department: requisition.requestbyUser.Department,
                jobGrade: requisition.requestbyUser.jobGrade,
                Staff_ID: requisition.requestbyUser.Staff_ID,
              },
              ...requisition?.requisitiontracks
                .slice(
                  0,
                  requisition?.requisitiontracks?.findIndex(
                    track => track.closedHere
                  ) !== -1
                    ? requisition?.requisitiontracks?.findIndex(
                        track => track.closedHere
                      ) + 1
                    : requisition?.requisitiontracks?.length
                )
                .filter(
                  el =>
                    el?.receivedbyUser &&
                    !["pending", "disapproved"].includes(lowerCase(el.status))
                )
                ?.map(el => ({
                  staff: el.receivedbyUser.Staff_ID,
                  staffName: el.receivedbyUser.Name,
                  Name: el.receivedbyUser.Name,
                  department: el.receivedbyUser.Department,
                  jobGrade: el.receivedbyUser.jobGrade,
                  Staff_ID: el.receivedbyUser.Staff_ID,
                })),
            ],
          }}
          setShowNewRequisitionModal={setShowNewRequisitionModal}
          handleCreatedRequisition={() => {
            refetch();
          }}
          itemsRequested={tableData}
        />
      ) : null}

      {Boolean(selectedVendorToRaiseGRNFor) ? (
        <>
          <RaisePurchaseRequestGrn
            defaultTableData={tableDataWithVendor
              .filter(
                el => el.Vendor_ID === selectedVendorToRaiseGRNFor.Vendor_ID
              )
              .map(el => ({
                Bar_Code: el.barcode,
                Item_Name: el.itemName,
                vendorName: el.vendorName,
                Vendor_ID: el.Vendor_ID,
                Vendor: el.Vendor_ID,
                InvoiceNo: el?.invoiceNumber,
                InvoiceAmount: currency(el.unitCost, {
                  symbol: "",
                  separator: "",
                })
                  .multiply(el.quantity)
                  .format(),
                Date_Log: new Date(),
                Quantity: el.quantity,
                UnitCost: el.unitCost,
                PurchasePrice: el.unitCost,
                InvoiceAmount: currency(el.unitCost, {
                  symbol: "",
                  separator: "",
                })
                  .multiply(el.quantity)
                  .format(),
                totalLandingCost: currency(el.unitCost, {
                  symbol: "",
                  separator: "",
                })
                  .multiply(el.quantity)
                  .format(),
                AmountDue: currency(el.unitCost, {
                  symbol: "",
                  separator: "",
                }).multiply(el.quantity).value,
                currency: requisition?.currency,
                conversionAmount: requisition.conversionAmount,
                Warehouse: el.Warehouse,
                UOM: el.UOM || "",
              }))}
            showUpdateInventoryModal={Boolean(selectedVendorToRaiseGRNFor)}
            setShowUpdateInventoryModal={setSelectedVendorToRaiseGRNFor}
            requisition={requisition}
            refetch={refetch}
            noVendorAccounting={Boolean(requisition.paymentType === "Advance")}
            onGRNPosted={onGRNPosted}
            taxType={
              vendorTaxes?.find(
                vendorTax =>
                  vendorTax.Vendor_ID ===
                    selectedVendorToRaiseGRNFor.Vendor_ID &&
                  vendorTax.invoiceNumber ===
                    selectedVendorToRaiseGRNFor.invoiceNumber
              )?.taxType
            }
          />{" "}
        </>
      ) : null}

      <ModalLoader
        show={
          postMutation.isLoading ||
          closeOutMutation.isLoading ||
          updateRequisitionMutation.isLoading ||
          postPrePaymentMutation.isLoading ||
          postAdvancePaymentMutation.isLoading
        }
      />
    </>
  );
}
